<template>
  <div>
    <label class="pre-inline">{{pre_item.name}}:</label>
    <el-radio-group v-show="dataHas" v-model="sel_radio" size="mini" @change="fun_option($event)">
      <el-radio v-for="(d,d_index) in pre_list_data" :key="d_index" :label="d.id" border>
        {{d.val}}
      </el-radio>
    </el-radio-group>

    <em v-show="pre_item.w=='1'">*</em><em v-show="pre_item.w=='0'"></em>
  </div>
</template>

<script>
  //
  import api from '@/utils/type.js';

  export default {
    name: "hj-radio",
    data() {
      return {
        pre_item: {},
        is_active: false,

        pre_api_action: '',
        pre_list_data: [],

        sel_radio: '1',

        dataHas: true,
        dataNo: false,

      }
    },
    props: {
      inData: {
        type: String,
        default: ''
      }
    },
    watch: {
      inData(val) {
        if (typeof(val) !== 'undefined' && val != '') {
          this.init(val);
        }
      }
    },
    created() {
      // console.log('hj-radio 组件激活时调用 创建');
      this.init_radio();
    },
    activated: function() {
      // console.log('hj-radio 组件激活时调用 激活');
      this.init_radio();
    },
    deactivated: function() {
      // console.log('hj-radio 组件激活时调用 停用');
      this.pre_item = {};
      this.pre_list_data = [];

      this.is_active = false;
    },
    methods: {
      init_radio: function() {
        if (!this.is_active) {
          this.pre_item = {};
          this.pre_item = JSON.parse(this.inData);
          // console.log(this.pre_item);

          if (this.pre_item.list.length > 0) {
            this.pre_list_data = this.pre_item.list;
            // console.log(this.pre_list_data);
          }

          this.sel_radio = this.pre_item.val;

          this.pre_api_action = '';
          this.pre_api_action = this.pre_item.sel_action;
          if (typeof(this.pre_api_action) !== 'undefined' && this.pre_api_action != '') {
            this.loaddata();
          }

          this.is_active = true;
        }
      },
      init: function(parm) {

        let r = JSON.parse(parm);
        // console.log('radio检测', r);
        this.pre_item = {};
        this.pre_item = r;

        let id = 0;
        let temp_name = '';
        let is_go = true;
        id = r.val;
        temp_name = r.sel_name;
        // console.log('id=' + id + ' temp_name=' + temp_name);
        if(this.pre_list_data.length==0 &&  this.r.list.length>0){
          this.pre_list_data=r.list;
        }

        if (id > 0) {
          for (let j = 0; j < this.pre_list_data.length; j++) {
            if (this.pre_list_data[j].id == id) {
              this.pre_item.val = this.pre_list_data[j].id;
              this.sel_radio=id;
              is_go = false;
              break;
            }
          }
        }

        if (is_go == true && temp_name != '') {
          for (let j = 0; j < this.pre_list_data.length; j++) {
            if (this.pre_list_data[j].val == temp_name) {
              this.pre_item.val = this.pre_list_data[j].id;
              this.sel_radio=this.pre_list_data[j].id;
              break;
            }
          }
        }


        this.val_back();
      },
      loaddata: function() {
        this.pre_list_data = [];

        this.$post(
          api.http_method, Method_EasySelect(this.pre_api_action)
        ).then(res => {
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == '1') {
            this.pre_list_data = res.data.data;
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            });
          }
        });

      },
      val_back: function() {
        this.$emit('com-event', this.pre_item);
      },
      fun_option: function(e) {
        console.log(e);
        this.pre_item.val = e;
        this.val_back();
      }
    }
  }
</script>

<style>
  .pre-inline {
    display: inline-block;
    vertical-align: middle;
  }
</style>
